<template>
  <div class="page-tips">
    <div class="tips-title"></div>
    <div class="tips-box">
      <div class="tips-content">
        <div class="tip-tl-bg"></div>
        <div class="tip-tr-bg"></div>
        <div class="tip-l-bg"></div>
        <div class="tip-r-bg"></div>
        <div class="content-text" v-html="notice">
          <!-- <p>根据《浙江省新冠肺炎防控旅游景区有序开放工作指南》，为保障您的健康安全，现XXXXXXX景区将进行采取线上分时免费预约制度，游客预约成功后，请在预约时段内有序入园。预约提示如下：</p>
          <p class="text-title">1、预约时间</p>
          <p>XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</p>
          <p class="text-title">2、预约方式</p>
          <p>XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</p>
          <p class="text-title">3、现场入园</p>
          <p>XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</p>
          <p class="text-title">4、其他</p>
          <p>XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</p> -->
        </div>
        <div class="content-btn" role="button" @click="toEdit()">我已知晓  确定预约</div>
      </div>
      <div class="tips-bg"></div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default{
  data () {
    return {
      notice: ''
    }
  },
  methods: {
    toEdit () {
      this.$router.push({
        path: '/edit'
      })
    }
  },
  mounted () {
    let scenic = this.getSession('scenic') || {}
    this.notice = scenic.notice
    document.title = '预约须知'
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.page-tips{
  width: 100%;
  height: 100%;
  // overflow-y: auto;
  // -webkit-overflow-scrolling: touch;
  // -ms-overflow-style: none;
  // overflow: -moz-scrollbars-none;
  box-sizing: border-box;
  padding-bottom: .27rem;
  position: relative;
  background: url('../assets/images/bg-yuyuexuzhi@2x.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .tips-title{
    width: 1.27rem;
    height: .32rem;
    margin-top: .27rem;
    background: url('../assets/images/text-yyxz.png') no-repeat;
    background-size: 100% 100%;
  }
  .tips-box{
    width: 3.38rem;
    height: 4.91rem;
    margin-top: .3rem;
    position: relative;
    .tips-content{
      width: 3.38rem;
      height: 4.91rem;
      background: #FFFFFF;
      border: 1px solid #3E3FFF;
      border-radius: 6px;
      position: relative;
      z-index: 2;
      box-sizing: border-box;
      padding: .22rem .15rem .37rem .22rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .content-text{
        width: 100%;
        font-size: .14rem;
        color: #666666;
        height: 3.83rem;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;
        &::-webkit-scrollbar{
          display: none;
          width: 0;
        }
        p{
          line-height: .2rem;
          word-break: break-all;
          word-wrap: wrap;
        }
        .text-title{
          margin-top: .15rem;
        }
      }
      .content-btn{
        width: 2.53rem;
        height: .36rem;
        font-size: .14rem;
        color: #FFFFFF;
        background-image: linear-gradient(270deg, #6398FF 0%, #3F80FF 100%);
        box-shadow: 0 .02rem .04rem 0 rgba(67,107,196,0.50);
        border-radius: .18rem;
        text-align: center;
        line-height: .36rem;
        font-weight: bold;
      }
      .tip-tl-bg{
        width: .3rem;
        height: .32rem;
        position: absolute;
        left: .45rem;
        top: -.25rem;
        background: url('../assets/images/jiazi@2x.png') no-repeat;
        background-size: 100% 100%;
        z-index: 3;
      }
      .tip-tr-bg{
        width: .3rem;
        height: .32rem;
        position: absolute;
        right: .45rem;
        top: -.25rem;
        background: url('../assets/images/jiazi@2x.png') no-repeat;
        background-size: 100% 100%;
        z-index: 3;
      }
      .tip-l-bg{
        width: .39rem;
        height: .17rem;
        position: absolute;
        left: -.14rem;
        bottom: 2.25rem;
        background: url('../assets/images/2xiaox@2x.png') no-repeat;
        background-size: 100% 100%;
        z-index: 3;
      }
      .tip-r-bg{
        width: .3rem;
        height: .3rem;
        position: absolute;
        right: -.18rem;
        top: 1.97rem;
        background: url('../assets/images/1xiaot@2x.png') no-repeat;
        background-size: 100% 100%;
        z-index: 3;
      }
    }
    .tips-bg{
      width: 3.38rem;
      height: 4.91rem;
      position: absolute;
      z-index: 1;
      left: .07rem;
      top: .07rem;
      background: #FFB861;
      border: 1px solid #3E3FFF;
      border-radius: .06rem;
    }
  }
}
.page-tips::-webkit-scrollbar{
  display: none;
  width: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ReservationTips.vue